module.exports = __webpack_public_path__ + "img/img3.48276731.png";